import {
	Select,
	Text,
	Upload,
	Number,
	FormGroupInterface,
	FORM_TYPE,
	VALIDATION_TYPE
} from '../../types';

export function getOtpVerificationForm(data: any = {}, on: any = {}) {
	const linkTrainerForm: FormGroupInterface = {
		label: '',
		submitText: 'Verify OTP',
		cancelText: 'Cancel',
		forms: [
			{
				label: '',
				formElements: [
					new Text('Enter Mobile One Time Password:', {
						name: 'mobileOtp',
						placeholder: 'Enter Received OTP',
						required: data.originationCategory === 'domestic' ? true : false,
						hide: data.originationCategory === 'domestic' ? true : false,
						row: false,
						onChange: on.sdmsIdChange,
						onBlur: on.sdmsIdBlur,
						charAllowedPattern: '[0-9]',
						maxFieldLength: 6
					}),
					new Text('Enter Email One Time Password:', {
						name: 'emailOtp',
						required: true,
						placeholder: 'Enter Received OTP',
						row: false,
						charAllowedPattern: '[0-9]',
						maxFieldLength: 6
					})
				]
			}
		]
	};
	return linkTrainerForm;
}
